import BroadCastViPlayer from "./BroadCastViPlayer";

export default BroadCastViPlayer;
